export default __webpack_public_path__ + "images/SpeakersPhotos/Maria_Lazaro.jpg?82159d3d";